<template>
  <div>
    <span
      v-if="label"
      class="display-value-label font-weight-medium text--primary text-truncate"
      v-text="label"
    />
    <br class="d-flex d-sm-none">
    <span
      class="display-value text--secondary"
    >
      {{ value | formatDate }}
    </span>
  </div>
</template>

<script>
  import Themeable from 'vuetify/lib/mixins/themeable'

  export default {
    name: 'DisplayDate',

    filters: {
      formatDate: (value) => {
        let formatted = ''

        if (value) {
          const date = new Date(value)
          formatted = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
        }

        return formatted
      },
    },

    mixins: [Themeable],

    props: {
      value: {
        type: String,
        default: null,
      },
      label: {
        type: String,
        default: null,
      },
    },
  }
</script>
